
let userInitiated = false;
// manu
function swapURL(imageHolder, image) {
    if (imageHolder.src !== image) {
        imageHolder.src = image;
        // imageHolder.onload = () => {
        //     imageHolder.classList.add('fade-in');
        //     setTimeout(() => {
        //         imageHolder.classList.remove('fade-in');
        //     }, 500);
        // };
        imageHolder.srcset = imageHolder.srcset.split(',').map(src => {
            const parts = src.split('&');
            parts.splice(0, 1, image)
            return parts.join('&');
        }).join(', ');
    }
}

function restoreMainImage(detail) {
    const section = detail.closest('.section');
    const imageHolder = section.querySelector('.image-with-text__media img');
    if (imageHolder.dataset.oginalSrc && imageHolder.dataset.oginalSrc !== '') {
        swapURL(imageHolder, imageHolder.dataset.oginalSrc);
    }
}

function replaceMainImage(detail) {
    const image = detail?.dataset?.image;
    if (image) {
        const section = detail.closest('.section');
        const imageHolder = section.querySelector('.image-with-text__media img');
        if (!imageHolder.dataset.oginalSrc) {
            imageHolder.dataset.oginalSrc = imageHolder.src;
        }
        swapURL(imageHolder, image);
    } else {
        restoreMainImage(detail);
    }
}

function enableCollapsibleImages() {
    const details = document.querySelectorAll('.image-with-stuff details');
    details.forEach((detail) => {
        detail.addEventListener('pointerdown', () => {
            userInitiated = true;
        });
        detail.addEventListener('toggle', (event) => {
            if (event.target.open) {
                replaceMainImage(detail)
            } else {
                if (userInitiated) {
                    restoreMainImage(detail)
                }
            }
            userInitiated = false;
        });
    });
}

enableCollapsibleImages();